/** Reveal an active field between the form's header and actions after keyboard resize. */
export function revealFlowInput() {
  const control = document.activeElement;
  if (
    !(control instanceof HTMLElement) ||
    !control.matches("input, textarea, [contenteditable=true]")
  )
    return;
  const shell = control.closest("[data-flow-presentation]");
  const footer = shell?.querySelector("footer");
  if (!footer) return;
  const bounds = control.getBoundingClientRect();
  const top =
    Math.max(
      window.visualViewport?.offsetTop ?? 0,
      shell?.querySelector("header")?.getBoundingClientRect().bottom ?? 0,
    ) + 12;
  const bottom = footer.getBoundingClientRect().top - 12;
  let delta =
    bounds.bottom > bottom
      ? bounds.bottom - bottom
      : bounds.top < top
        ? bounds.top - top
        : 0;
  if (!delta) return;
  let parent = control.parentElement;
  while (parent && parent !== document.body) {
    if (
      /(auto|scroll)/.test(getComputedStyle(parent).overflowY) &&
      parent.scrollHeight > parent.clientHeight
    ) {
      const before = parent.scrollTop;
      parent.scrollBy({ top: delta, behavior: "instant" });
      delta -= parent.scrollTop - before;
      if (Math.abs(delta) < 1) return;
    }
    parent = parent.parentElement;
  }
  window.scrollBy({ top: delta, behavior: "instant" });
}
